import { render, staticRenderFns } from "./BindA3.vue?vue&type=template&id=4e8626fb&scoped=true&"
import script from "./BindA3.vue?vue&type=script&lang=js&"
export * from "./BindA3.vue?vue&type=script&lang=js&"
import style0 from "./BindA3.vue?vue&type=style&index=0&id=4e8626fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8626fb",
  null
  
)

export default component.exports